import { render, staticRenderFns } from "./writeXaAchievements.vue?vue&type=template&id=24631194&scoped=true"
import script from "./writeXaAchievements.vue?vue&type=script&lang=js"
export * from "./writeXaAchievements.vue?vue&type=script&lang=js"
import style0 from "./writeXaAchievements.vue?vue&type=style&index=0&id=24631194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24631194",
  null
  
)

export default component.exports